export default "__VITE_ASSET__DECcCzv0__"